import React, { useState } from "react";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { map } from "lodash";
import { ImageLightBox } from "components/shared/ImagesGalleryPage";

type ImageAttachmentsArgs = {
  chatId: string;
  id: string;
  images: {
    content_type: string;
    extension: string;
    id: string;
    name: string | null;
    original_filename: string;
    size: number;
  }[];
};

export default function ImageAttachments({
  images,
  chatId,
  id,
}: ImageAttachmentsArgs) {
  const dispatch = useDispatch();
  const previewImages = images.slice(0, 4);

  const [lightbox, setLightbox] = useState<{
    id: string | null;
    open: boolean;
    loading: boolean;
  }>({ id: null, open: false, loading: false });
  function showImageGallery(
    e: React.MouseEvent<HTMLButtonElement>,
    imageId: string | null,
  ) {
    e.preventDefault();
    if (images.length > 1) {
      dispatch({
        type: "chat/NAVIGATE",
        payload: {
          route: "showMessageImageGallery",
          params: { chatId, id, imageId },
        },
      });
    } else {
      setLightbox({
        id: imageId,
        open: true,
        loading: lightbox.id != imageId,
      });
    }
  }

  function onImageLoad() {
    const scrollContainer = document.querySelector(".chat__messages_container");
    if (scrollContainer) {
      scrollContainer.scrollTop = scrollContainer.scrollHeight; // Dereferenziert Scroll-Position nach dem Bild-Laden
    }
  }

  return (
    <div
      className={classNames(
        "grid gap-1 grid-cols-1 grid-rows-1 min-w-content",
        {
          "grid-cols-2": previewImages.length > 1,
          "grid-rows-2": previewImages.length > 2,
        },
      )}
    >
      {map(previewImages, (image, index) => (
        <button
          onClick={(e) => showImageGallery(e, index < 3 ? image.id : null)}
          className={classNames(
            "stack-container w-full overflow-hidden rounded overflow-hidden",
            { "aspect-square": images.length > 1 },
          )}
          key={index}
        >
          <img
            alt={image.original_filename}
            className={classNames(
              "w-full h-full object-cover stack-item object-center transition hover:scale-110",
              {
                "blur-sm": index === 3 && images.length > 4,
                "w-auto h-auto max-w-full max-h-full": images.length === 1,
              },
            )}
            src={`/api/storage/images/${image.id}/get/457x457`}
            onLoad={onImageLoad}
          />
          {index === 3 && images.length > 4 && (
            <div className="stack-item rounded flex justify-center items-center text-3xl font-bold text-white gap-1 backdrop-brightness-50 hover:backdrop-brightness-75 transition">
              <span>+</span>
              <span>{images.length - 4}</span>
            </div>
          )}
        </button>
      ))}
      <div className="z-50">
        <ImageLightBox
          images={images}
          setLightbox={setLightbox}
          lightbox={lightbox}
        />
      </div>
    </div>
  );
}
